<div *ngIf="permissions.includes('access' && 'edit_winmedia_spots')">
  <full-calendar #fullCalendar [options]="calendarOptions"></full-calendar>

  <mat-radio-group aria-labelledby="spots-radio-group-label"
                   class="spots-radio-group"
                   [(ngModel)]="selectedSpot">
    <mat-radio-button class="spots-radio-button" *ngFor="let spot of spots" [value]="spot">
      {{ spot.name }}
    </mat-radio-button>
  </mat-radio-group>

  <div>Campagne : <b>{{ campaignName }} ({{displayPeriode()}})</b></div>
  <div>Spots programmées : <b>{{ counter }}</b></div>
  <div>Stations sélectionnées : <b>{{ stations }}</b></div>
  <div>Slot : <b>{{ slot }}</b></div>

  <div>
    <button (click)="saveCampaign()" style="background: #3d465a; color: white; margin-top: 20px;" mat-button>Save Campaign</button>
  </div>
</div>
